import DefaultLayout from "@/layouts/DefaultLayout";
import KCalendarEventForm from "kinnect-front/KCalendar/KCalendarEventForm";
import { CalendarEvent } from "kinnect-models";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";

export default {
	name: "CalendarEventPage",

	metaInfo() {
		const title = this.editing
			? "Calendar - Edit Calendar Event"
			: "Calendar - Add to Calendar";

		return { title };
	},

	props: { idCalendarEvent: Number },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		deleteDialogOpen: false,
		event: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idCalendarEvent );
		},

		idUser() {
			return this.$store.getters["auth/userID"];
		},

		canDelete() {
			return this.event && ( this.event.idUser === this.idUser
				|| this.$can( "browse_admin" ) );
		},

		genDeleteDialog() {
			if ( this.editing && this.event && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					disabled={!this.canDelete}
					loading={this.$wait.is( "delete calendar event" )}
					onConfirm={() => this.event.delete()}
					redirect={[ "back", { name: "front" } ]}
					title="Delete Calendar Event"
					vModel={this.deleteDialogOpen}
				>
					{this.canDelete
						? "Are you sure you want to delete this calendar event?"
						: "You can't delete this calendar event because you're not the owner of it."
					}
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Event",
					tooltip: "Delete this calendar event"
				};
			}
		}
	},

	methods: {
		async fetchCalendarEvent() {
			if ( this.editing ) {
				this.event = await CalendarEvent.findPageModel( this.idCalendarEvent );
			}
		},

		async fetch() {
			await this.fetchCalendarEvent();
		}
	},

	render() {
		if ( !this.fetched ) {
			return;
		}

		return <DefaultLayout maxWidth="600px">
			<KCalendarEventForm event={this.event}></KCalendarEventForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
